import { ICellEditorParams } from "@ag-grid-community/core";
import { Box, Radio, RadioGroup, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { IRegistryDataColumn } from "../../../models/RegistryDataColumn";

export const EditorRadio = React.forwardRef((props: ICellEditorParams, ref) => {
  const inputRef = React.useRef<any>();

  const [value, setValue] = React.useState(props.value);

  const colDef = props.colDef as any;
  const colMeta = colDef.meta as IRegistryDataColumn;

  const options = colMeta.options;

  const inputHandler = (value) => {
    setValue(value);
  };

  React.useImperativeHandle(ref, () => {
    return {
      getValue: () => {
        return value;
      },

      afterGuiAttached: () => {
        setValue(props.value);
        inputRef.current.focus();
        inputRef.current.select();
      },
    };
  });

  return (
    <Box>
      <RadioGroup onChange={inputHandler} value={value} ref={inputRef}>
        <Stack spacing={4} p={4}>
          {options &&
            Object.entries(options).map(([key, option]) => (
              // We use label here, because we convert on grid load to the label for display
              <Radio key={key} value={option.label}>
                <Text>{option.label}</Text>
              </Radio>
            ))}
        </Stack>
      </RadioGroup>
    </Box>
  );
});
